/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { validateNumber } from "ember-changeset-validations/validators";
import type { Payload } from "parog-web/components/forc/abstract/journal-event-based-component";
import BaseMedicalHistoryFormComponent from "parog-web/components/medical-history/abstract/base-edition-form";
import MedicalHistoryBaseEditionForm from "../base-edition-form";

export default class MedicalHistoryFormComponent extends BaseMedicalHistoryFormComponent {
  MedicalHistoryBaseEditionForm = MedicalHistoryBaseEditionForm;

  journalEventProperties = [
    ...this.sharedProperties,
    ...this.renalPathologyProperties,
    ...this.pulmonaryPathologyProperties
  ];

  get validations(): Record<string, unknown> {
    return {
      creatinineThreeMonthsAfterTransplant: validateNumber({
        gte: 20,
        lte: 2000,
        allowBlank: true,
        description: "La quantité de créatinine après 3 mois"
      })
    };
  }

  get renalPathologyProperties(): string[] {
    return [
      "transplantDate",
      "transplantRank",
      "nephropatie",
      "donorType",
      "immunologicalRisk",
      "incompatibleABO",
      "donorCreatinine",
      "abmClassification",
      "creatinineThreeMonthsAfterTransplant",
      "rejectsFirstYear",
      "mrcStage",
      "mrcPreexistingTransplant",
      "transplantedOrgan",
      "cytomegalovirusStatus"
    ];
  }

  get pulmonaryPathologyProperties(): string[] {
    return [
      "transplantedOrgan",
      "underlyingDisease",
      "transplantDate",
      "transplantRank",
      "cytomegalovirusStatus"
    ];
  }

  retrieveModel(): Record<string, unknown> {
    const model = super.retrieveModel();
    if (!this.isLoadedFromJe) {
      model.transplantedOrgan = null;
    }

    return model;
  }

  computePayload(): Payload {
    const payload = super.computePayload();

    if (!this.args.patient.isMrc) {
      delete payload.mrcStage;
      delete payload.mrcPreexistingTransplant;
    }
    if (!this.args.patient.isTransplanted) {
      delete payload.transplantedOrgan;
    }

    return payload;
  }
}
